module.exports = __webpack_public_path__ + "static/media/backgroundImg1.75462ca1.jpg";